import { useEffect } from 'react';
import { connect } from 'react-redux';
import ClientLogin from './pages/Login';
import ClientDashboard from './pages/ClientDashboard';
import { checkToken, clientTokenLogin } from "../../redux/actions/clientActions";
import queryString from 'query-string';

const Distributor = ({ isAuthenticated, checkToken, location, tokenLogin }) => {

    useEffect(() => {
        const { token } = queryString.parse(location.search);
        if (token) {
            tokenLogin({ token });
        } else {
            checkToken();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {
                isAuthenticated
                    ? <ClientDashboard />
                    : <ClientLogin />
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.client.isAuthenticated
    };
};

const mapDispatchToProps = dispatch => {
    return {
        checkToken: () => dispatch(checkToken()),
        tokenLogin: token => dispatch(clientTokenLogin(token))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Distributor);